<template>
  <div>
    <Panel :class="panelwithCollapse">
      <template #header>
        <div class="p-grid">
          <div
            class="p-col-11 paddingTop10Px buttonCollapsePanel"
            @click="expandOrCollapse()"
          >
            <a class="buttonCollapsePanel">
              <span :class="expandClass"></span>
              <span class="titleHeader">
                <b>{{
                  $t("operacion.detalleOperacion.listaMensajesOperacion.titulo")
                }}</b>
              </span>
            </a>
          </div>
        </div>
      </template>
      <div v-if="contentPanel">
        <MensajesReclamacion
          v-for="reclamacion in reclamaciones"
          :key="reclamacion.token"
          :tokenReclamacion="reclamacion.token"
        />
      </div>
    </Panel>
  </div>
</template>

<script>
import { CLASS_COLLAPSED_ALL, CLASS_EXPANDED_ALL } from "@/resources/constants";
import MensajesReclamacion from "@/components/portal-gran-cliente/Expedientes/MensajesReclamacion.vue";

export default {
  name: "ListaDocumentosEnvioOperacion",
  props: ["claims"],
  components: {
    MensajesReclamacion,
  },
  data() {
    return {
      reclamaciones: [],
      expandClass: CLASS_COLLAPSED_ALL,
      contentPanel: false,
      panelwithCollapse: "panelwithCollapse collapsed",
    };
  },
  methods: {
    expandOrCollapse() {
      this.expandClass.includes("pi-chevron-right") == true
        ? this.expandAll()
        : this.collapseAll();
    },
    expandAll() {
      this.expandClass = CLASS_EXPANDED_ALL;
      this.panelwithCollapse = "panelwithCollapse open";
      this.contentPanel = true;
    },
    collapseAll() {
      this.expandClass = CLASS_COLLAPSED_ALL;
      this.panelwithCollapse = "panelwithCollapse collapsed";
      this.contentPanel = false;
    },
  },
  watch: {
    claims(newValue) {
      if (newValue) {
        this.reclamaciones.splice(0, this.reclamaciones.length, ...newValue);
      }
    },
  },
};
</script>